module.exports = __webpack_public_path__ + "img/bc.c629be90.svg";